import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { CashOccurrenceType } from '../../../app/enums';
import {
    useLiquidityOneOffCashflowSettings,
    useSelectAllLiquidityOneOffCashflowItems,
    useUpdateLiquidityOneOffCashflowItemSettings,
    useUpdateLiquidityOneOffCashflowPanelSettings,
} from '../../api';
import { useLiquidityCalculationData, useLiquidityScopeUpdating } from '../../hooks';
import { LiquidityCashflowSettingBox } from './liquidity-cashflow-setting-box';

interface IProps {
    expandedKey?: string;
}

export const LiquidityOneOffCashflowSettings: FunctionComponent<IProps> = ({ expandedKey }) => {
    const { t } = useTranslation();
    const calculationData = useLiquidityCalculationData();
    const { data: cashEventsSettings, isFetching } = useLiquidityOneOffCashflowSettings();
    const isScopeUpdating = useLiquidityScopeUpdating();

    const updateCashEventSettings = useUpdateLiquidityOneOffCashflowPanelSettings();
    const updateCashEventItem = useUpdateLiquidityOneOffCashflowItemSettings();
    const selectAllCashEvents = useSelectAllLiquidityOneOffCashflowItems();

    if (calculationData.isLoading) return null;

    return (
        <LiquidityCashflowSettingBox
            title={t('oneOffCashflows')}
            cashOccurrenceType={CashOccurrenceType.ONE_OFF}
            settings={cashEventsSettings}
            updatePanelSettings={updateCashEventSettings}
            updateItemSettings={updateCashEventItem}
            selectAllItems={selectAllCashEvents}
            sectionKey="cashflows"
            expandedKey={expandedKey}
            isUpdating={isFetching || isScopeUpdating}
        />
    );
};
